// extracted by mini-css-extract-plugin
export var filterIncDec = "_4n-0";
export var leftBorder = "_4n-1";
export var rightBorder = "_4n-2";
export var stringInput = "_4n-3";